import { c as _c } from "react/compiler-runtime";
import { Text, TextProps } from '@chakra-ui/react';
export const TextSpan = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Text as="span" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};